<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-if="isReady" :key="$i18n.locale" />
    <loading-indicator v-else :text="$t('Initialization')" />
  </router-view>
</template>

<script>
  import { SplashScreen } from '@capacitor/splash-screen'
  import { ScreenOrientation } from '@capacitor/screen-orientation'

  import LoadingIndicator from '@/components/loadingIndicator.vue'

  export default {
    name: 'App',
    components: { LoadingIndicator },
    data () {
      return {
        isReady: false,
        intervalStepper: undefined
      }
    },
    created () {
      this.$i18n.locale = this.$store.state.settings.locale

      this.$store
        .dispatch('init')
        .then(() => this.onDeviceReady())
    },
    beforeUnmount () {
      clearInterval(this.intervalStepper)
      this.intervalStepper = undefined
    },
    methods: {
      onDeviceReady () {
        if (this.isReady) return
        this.isReady = true
        this.intervalStepper = setInterval(() => { this.$store.dispatch('device/refresh') }, 1000)
        if (window.screen.width < 600) ScreenOrientation.lock('portrait')
        SplashScreen.hide()

        try {
          // eslint-disable-next-line no-undef
          AndroidFullScreen.immersiveMode()
        } catch (_) {}
      }
    }
  }
</script>
